import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";

function Tarifas() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      <div className="main" style={{ marginTop: "8em" }}>
        <div className="section">
          <Container>
            <h3 className="title-uppercase text-center" style={{fontWeight:500,fontFamily: "'Noto Sans SC', sans-serif", marginTop: "4em"}}>
            Tarifas
            </h3>
            <br></br>
            <Row>
              <Col md="2">
                <center>
                  <button type="button" className="btn btn-outline-light">
                    <a
                      href="#tarifas-2026"
                      role="button"
                      style={{textDecoration: "none !important"}}
                      onClick={(e) => {
                        e.preventDefault();
                        downloadPdfFromJson(
                          "/tarifas-notariales-2026.json",
                          "RES-tarifas-notariales-2026-000964-6.pdf"
                        );
                      }}
                    >
                      <img
                        alt="Imagen con referencia Tarifas Notariales 2026"
                        width="80px"
                        src={require("assets/img/sections/pdf.jpg")}
                      ></img>
                      <h6>TARIFAS NOTARIALES 2026</h6>
                    </a>
                  </button>
                </center>
              </Col>
              <Col md="2">
                <center>
                  <button type="button" className="btn btn-outline-light">
                    <a
                      href="#tarifas-dtr-2025"
                      role="button"
                      style={{textDecoration: "none !important"}}
                      onClick={(e) => {
                        e.preventDefault();
                        downloadPdfFromJson(
                          "/tarifas-dtr-sdr-2025.json",
                          "TARIFAS-2025-DTR-SDR.b4f88682.pdf"
                        );
                      }}
                    >
                      <img
                        alt="Imagen con referencia Resolucion Tarifas DTR"
                        width="80px"
                        src={require("assets/img/sections/pdf.jpg")}
                      ></img>
                      <h6>RESOLUCION TARIFAS DTR</h6>
                    </a>
                  </button>
                </center>
              </Col>                    
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Tarifas;
